/* tslint:disable */
/* eslint-disable */
/**
 * DaaS
 * Data as a Service - website backend for frontend.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: maritime_support@gatehouse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
  /**
   * Access token, used to gain access to the rest of the API
   * @type {string}
   * @memberof LoginResponse
   */
  token?: string;
  /**
   * Expiration timer, for when token is no longer valid
   * @type {string}
   * @memberof LoginResponse
   */
  expires?: string;
}

/**
 * Check if a given object implements the LoginResponse interface.
 */
export function instanceOfLoginResponse(value: object): boolean {
  let isInstance = true;

  return isInstance;
}

export function LoginResponseFromJSON(json: any): LoginResponse {
  return LoginResponseFromJSONTyped(json, false);
}

export function LoginResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LoginResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    token: !exists(json, 'token') ? undefined : json['token'],
    expires: !exists(json, 'expires') ? undefined : json['expires'],
  };
}

export function LoginResponseToJSON(value?: LoginResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    token: value.token,
    expires: value.expires,
  };
}
